import { EXPORT_DATA } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case EXPORT_DATA:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
